import styled from 'styled-components';
import { colors } from 'src/utils/styles/global.style';

export const StyledTerms = styled.div`
  padding: 25px;
  width: 75vw;
  height: 50vh;
  /* background-color: #e5e5e5; */
  margin: auto;
  h4 {
    text-transform: capitalize;
    margin-top: 30px;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;

  .document_link {
    text-transform: capitalize;
    text-decoration: underline;
    font-weight: bold;
  }
`;

export const Content = styled.div`
  border: 1.5px solid ${colors('primary')};
  border-radius: 0.25rem;
  > div {
    position: relative;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 400px;
    div:first-of-type {
      margin: 20px 20px 0 20px;
    }
  }
`;

export const Fadeout = styled.div`
  position: sticky;
  bottom: 0;
  height: 4em;
  width: 100%;
  background: -webkit-linear-gradient(rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
  background-image: -moz-linear-gradient(rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
  background-image: -o-linear-gradient(rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
  background-image: linear-gradient(rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
  background-image: -ms-linear-gradient(rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
`;

export const ErrorMessageStyle = styled.span`
  color: gray;
  margin-top: 16px;
  font-weight: 700;
`;
